'use client';
import { extends as e } from '../../_virtual/_rollupPluginBabelHelpers.js';
import o from 'next/link';
import { usePathname as r } from 'next/navigation';
import t, { forwardRef as n, useState as i, useEffect as l } from 'react';
import c from '../../react-client/useLocale.js';
import { isLocalizableHref as p, prefixHref as a, localizeHref as s } from '../../shared/utils.js';
import f from './syncLocaleCookie.js';

function m(n, m) {
  let { href: h, locale: u, localePrefixMode: d, onClick: k, prefetch: x, prefix: L, defaultLocale, ...g } = n;
  const j = r(), v = c(),
    C = u !== v, [y, w] = i((() => ((v === defaultLocale) && !C) ? h : p(h) && ('never' !== d || C) ? a(h, L) : h));
  return l((() => {
    j && w(s(h, u, v, j, L));
  }), [v, h, u, j, L]), C && (x && console.error('The `prefetch` prop is currently not supported when using the `locale` prop on `Link` to switch the locale.`'), x = !1), t.createElement(o, e({
    ref: m,
    href: y,
    hrefLang: C ? u : void 0,
    onClick: function(e) {
      f(j, v, u), k && k(e);
    },
    prefetch: x,
  }, g));
}

const h = n(m);
h.displayName = 'ClientLink';
export { h as default };
